import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "news"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "news-info"
};
const _hoisted_5 = {
  class: "news-title"
};
const _hoisted_6 = {
  class: "news-sub-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("img", {
    class: "title",
    src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/29eef2b2cd1844098582786860966ea9.png"
  }, null, -1)), _createElementVNode("div", {
    class: "more",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleMore && $options.handleMore(...args))
  }, _cache[2] || (_cache[2] = [_createElementVNode("span", {
    class: "text"
  }, "查看更多", -1), _createElementVNode("span", {
    class: "icon"
  }, null, -1)]))]), $data.newslist[0] ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "content",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleDetail && $options.handleDetail(...args))
  }, [_createElementVNode("img", {
    class: "news-img",
    src: $data.newslist[0].cover_url || 'https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/19bcbf8491b94c1cb6e1a2f0568056ad.png'
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($data.newslist[0].news_name), 1), _createElementVNode("div", _hoisted_6, _toDisplayString($data.newslist[0].context), 1)]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "news-arrow"
  }, null, -1))])) : _createCommentVNode("", true)]);
}